import { Component, OnInit, ChangeDetectionStrategy, input } from '@angular/core';
import { NgxGlideComponent } from 'ngx-glide';
import { IconComponent } from '@teamfoster/sdk/icon';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-infographic-slider',
  templateUrl: './infographic-slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxGlideComponent, IconComponent, FromDictionaryPipe],
})
export class InfographicSliderComponent implements OnInit {
  readonly diseaseProfileTitle = input<string>();
  readonly knowledgeCardsUrl = input<string>();
  readonly images = input<
    {
      imageUrl: string;
      caption: string;
    }[]
  >();

  constructor() {}

  ngOnInit(): void {}
}
